import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useModulo from "./useModulo";
import { isDiretorSelector, isGestorSelector, isOperadorSelector, isSuperUsuarioSelector } from "@/store/autenticacao";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function usePaginas() {
  const { t } = useTranslation();
  const isDiretor = useSelector(isDiretorSelector);
  const isSuperUsuario = useSelector(isSuperUsuarioSelector);
  const isOperator = useSelector(isOperadorSelector);
  const isGestor = useSelector(isGestorSelector);
  const { hasModulo } = useModulo();
  const history = useHistory();
  const handleClick = ({ key }) => {
    history.push(key);
  };

  const paginas = [
    { label: t("Ambientes"), key: "/ambientes", hidden: !isSuperUsuario, subgrupo: "Configurações", onClick: handleClick },
    { label: t("Áreas de Atuação"), key: "/consultivo/areas", hidden: !(hasModulo("consultivo") && isDiretor), subgrupo: "Configurações", onClick: handleClick },
    { label: t("Modelos"), key: "/modelos", hidden: !isDiretor, subgrupo: "Configurações", onClick: handleClick },
    { label: t("Signatários"), key: "/signatarios", hidden: !isDiretor, subgrupo: "Configurações", onClick: handleClick },
    { label: t("Usuários"), key: "/usuarios", hidden: !isDiretor, subgrupo: "Configurações", onClick: handleClick },
    { label: t("Armazenamento em Uso"), key: "/armazenamento-em-uso", hidden: !isOperator, subgrupo: "Histórico", onClick: handleClick },
    { label: t("E-mails"), key: "/emails", hidden: !isSuperUsuario, subgrupo: "Histórico", onClick: handleClick },
    { label: t("Logs"), key: "/logs?categoria=/", hidden: !isSuperUsuario, subgrupo: "Histórico", onClick: handleClick },
  ].filter((p) => !p.hidden);

  const paginasPorSubgrupo = paginas.reduce((acc, pagina) => {
    const grupo = pagina.subgrupo ?? "sem-grupo";
    if (!acc[grupo]) acc[grupo] = [];
    acc[grupo].push(pagina);
    return acc;
  }, {});

  return { paginas, paginasPorSubgrupo };
}
